import styled from 'styled-components';
import { colorCSS } from '../..';
import { getIcon } from '../../icons';
export const Banner = styled.div `
  text-align: left;
  padding: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;

  ${({ themeInitial }) => themeInitial
    ? `background-color: ${colorCSS(`${themeInitial}50`, 0.4)};`
    : ''}

  div > a {
    background-color: ${colorCSS(`N0`)};
    font-size: 1rem;
    line-height: 1.5rem;
    padding: 0.75rem 1rem;
    ${({ themeInitial }) => themeInitial
    ? `border: 1px solid ${colorCSS(`${themeInitial}200`)};
           &:hover {
             border: 1px solid ${colorCSS(`${themeInitial}200`)};
             background-color: ${colorCSS(`${themeInitial}50`)};
           }
          &:active {
            border: 1px solid ${colorCSS(`${themeInitial}200`)};
            background-color: ${colorCSS(`${themeInitial}50`)};
          }
          &:focus {
            border: 1px solid ${colorCSS(`${themeInitial}200`)};
            background-color: ${colorCSS(`${themeInitial}50`)};
          }`
    : ''}
  }

  div > a > span {
    color: ${colorCSS('N800')};
  }
`;
export const BannerIcon = styled.div `
  svg {
    ${({ themeInitial }) => themeInitial
    ? `path {
            fill: ${colorCSS(`${themeInitial}200`)};
          }`
    : `path {
            fill: ${colorCSS(`N100`)};
          }`}
    height: 1.2rem;
    width: auto;
  }
  ${({ icon }) => icon && getIcon(icon) ? `padding: 0 0.8rem 0.3rem 0.4rem;` : 'padding: 0;'}
`;
export const BannerTitleContainer = styled.div `
  display: flex;
  padding-bottom: 0.25rem;
  line-height: 1rem;
`;
export const BannerTitle = styled.h4 `
  color: ${colorCSS('N800')};
  font-weight: normal;
  font-family: 'Charlie Text';
  font-size: 1rem;
  line-height: 1.25rem;
  padding-right: 0.3rem;
`;
export const BannerDescription = styled.p `
  color: ${colorCSS('N400')};
  font-size: 0.75rem;
  line-height: 1rem;
  margin-bottom: 1rem;
`;
//# sourceMappingURL=UiBanner.styles.js.map